import { render, staticRenderFns } from "./productItem3.vue?vue&type=template&id=9c22eaaa&scoped=true&"
import script from "./productItem3.vue?vue&type=script&lang=js&"
export * from "./productItem3.vue?vue&type=script&lang=js&"
import style0 from "./productItem3.vue?vue&type=style&index=0&id=9c22eaaa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c22eaaa",
  null
  
)

export default component.exports